import { css } from 'styled-components/macro';
import { textRegularLineHeight } from '../../../components/Typography';

export const toolbarIconStyles = css`
  height: ${textRegularLineHeight}rem;
  width: ${textRegularLineHeight}rem;
  padding: 0.4rem;
`;
